// #region IMPORT
import React, { useState, useEffect, useMemo } from 'react';
/** Services Import */
import Global from '../../Services/Common/Global';
import Commons from '../../Services/Common/Common';
/** Components Import */
import { useSelector } from 'react-redux';
import Profile from './Profile';
import { useDispatch } from 'react-redux';
import { NavBarInfoActions } from '../../Reducer/NavBarInfoReducer';
import { closeLoading, showLoading } from '../../Reducer/LoadingReducer';
import { showSnackbar } from '../../Reducer/SnackbarReducer';
import { useAppNavigate } from '../../Hooks/back/useAppNavigate';
// #endregion

function ProfileFunction() {
  // #region 변수
  const dispatch = useDispatch();
  const { navigate, popPage } = useAppNavigate();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const codeInfo = useSelector((state) => state.code.codeInfo);
  const bloodList = useMemo(
    () =>
      (codeInfo || [])
        .filter((item) => item.groupCd === 'BloodType')
        .map((item) => ({
          name: item.codeNm,
          value: item.code,
        })),
    [codeInfo]
  );
  const [modalToggle4, setModalToggle4] = useState(); // 회원탈퇴 모달
  const [idDelete, setIdDelete] = useState(false);
  const [careerPeriodList, setCareerPeriodList] = useState([]);
  const [nationList, setNationList] = useState([]); //국적 코드
  const [deptList, setDeptList] = useState([]); //부서 목록
  // 필드 기본값은 userInfo 에서 로드
  const [inputs, setInputs] = useState({
    bloodType: userInfo?.bloodType ?? '',
    decUserId: userInfo?.decUserId ?? '',
    userNm: userInfo?.userNm ?? '',
    userTel: userInfo?.tel ?? '',
    birth: userInfo?.birth ?? '',
    post: userInfo?.post ?? '',
    address: userInfo?.address ?? '',
    coCd: userInfo?.coCd ?? '',
    coNm: userInfo?.coNm ?? '',
    custCd: userInfo?.custCd ?? '',
    custNm: userInfo?.custNm ?? '',
    depCd: userInfo?.depCd ?? '',
    depNm: userInfo?.depNm ?? '',
    affiliationNm: userInfo?.affiliationNm ?? '',
    rank: userInfo?.rank ?? '',
    userPw: '',
    userPwConfirm: '',
    identityConfirm: true,
    identityErrMsg: '',
  });
  // #endregion

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('개인정보 수정'));
    Init();
  }, []);

  const Init = async () => {
    dispatch(showLoading());

    try {
      await SearchDept();
    } catch (e) {
      console.log('Error: ', e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };

  // #region 조회
  // 부서 목록 조회 (userInfo.custCd 기준)
  const SearchDept = async () => {
    if (!userInfo?.custCd) {
      setDeptList([]);
      return;
    }

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.getDepartments,
        { CustCd: Commons.EncryptAES(userInfo.custCd) }
      ).then((result) => {
        let data = result.data;
        console.log('부서 목록', data);
        if (data && data.length > 0) {
          if (data[0].type === 'Error') {
            throw new Error(data[0].message);
          } else {
            setDeptList(
              data.map((item) => ({
                value: item.depCd,
                name: item.depNmLast || item.depCd,
              }))
            );
          }
        } else {
          setDeptList([]);
        }
      });
    } catch (e) {
      console.log(e);
      setDeptList([]);
    }
  };

  // #endregion

  // #region 저장
  // 개인정보 수정
  const SaveLogic1 = async () => {
    dispatch(showLoading());

    try {
      const fullAddress =
        `${inputs.address1 || ''} ${inputs.address2 || ''}`.trim();

      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Account.updateProfile,
        {
          BloodType: Commons.EncryptAES(inputs.bloodType) || '',
          Address: Commons.EncryptAES(fullAddress || inputs.address) || '',
          AffiliationNm: Commons.EncryptAES(inputs.affiliationNm) || '',
          Rank: Commons.EncryptAES(inputs.rank) || '',
          UserId: userInfo.userid || '',
        }
      ).then((result) => {
        let data = result.data;

        if (data.type === 'Ok') {
          dispatch(showSnackbar({ message: data.message, type: 'success' }));
        } else {
          throw new Error(data.message ? data.message : '');
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };
  // #endregion

  // #region 삭제
  // 회원 탈퇴
  const DeleteLogic1 = async (_item) => {
    dispatch(showLoading());

    try {
      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Account.deleteAccount,
        {
          UserId: userInfo.userid || '',
        }
      ).then(async (result) => {
        let data = result.data;

        if (data.type === 'Ok') {
          window.localStorage.setItem(
            'auth',
            JSON.stringify({
              auth: false,
            })
          );

          dispatch(showSnackbar({ message: data.message, type: 'success' }));
          popPage();
          navigate('/', { replace: true });
        } else {
          throw new Error(data.message ? data.message : '');
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };
  // #endregion

  // #region 나머지 함수
  window.onbeforeunload = function () {
    window.location.href = '/';
  };
  // #endregion

  return (
    <div className="wrap">
      <Profile
        userInfo={userInfo}
        lanInfo={lanInfo}
        careerPeriodList={careerPeriodList}
        setCareerPeriodList={setCareerPeriodList}
        inputs={inputs}
        setInputs={setInputs}
        idDelete={idDelete}
        setIdDelete={setIdDelete}
        modalToggle4={modalToggle4}
        setModalToggle4={setModalToggle4}
        bloodList={bloodList}
        nationList={nationList}
        setNationList={setNationList}
        deptOptions={deptList}
        // 함수
        SaveLogic1={SaveLogic1}
        DeleteLogic1={DeleteLogic1}
      />
    </div>
  );
}

export default ProfileFunction;
